// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  at: __t.timestamp(),
  actorUserId: __t.string().name("actor_user_id"),
  actorName: __t.string().name("actor_name"),
  orgId: __t.string().name("org_id"),
  action: __t.string(),
  target: __t.string(),
  detail: __t.string(),
});
